import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { CustomizeHomepagePage } from 'pages/customize-homepage/customize-homepage-page';

@NgModule({
  declarations: [CustomizeHomepagePage],
  imports: [PagesModule, ComponentsModule]
})
export class CustomizeHomepagePageModule {}
